import request from "@/network/request"

// 查询微信公众号处方支付信息
export function requestInvoicePrescription(data) {
	return request({
		url: "/api/scan/scanAdviceInfo",
		method: 'post',
		data,
	});
}
// 获取用法用量数据
export function requestPrescriptionUsage(data) {
	return request({
		url: "/api/scan/scanAdviceDetail",
		method: 'post',
		data,
	});
}

// 获取
export function requestGetJsticket(data) {
	return request({
		url: "/api/app/official/getJsticket",
		method: 'post',
		data,
	});
}
